export default "__VITE_ASSET__DSIq088Y__"